import React, { Fragment, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Grid, Chip } from "@material-ui/core";
import styles from "../setting.module.css";
import ModalCloseButton from "../../../components/UI/ModalCloseButton";
import Avatar from "@mui/material/Avatar";
import useAxiosPrivate from "../../../utils/hooks/useAxiosPrivate";
import { useSelector } from "react-redux";
import CoachManagementModalForAdmin from "./coachManagementForAdmin";
import CoachManagementModalForSuperAdmin from "./coachManagementForSuperAdmin";

const styleForAdmin = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 700,
  bgcolor: "background.paper",
  borderRadius: "5px",
  p: 4,
};

const styleForCoach = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 810,
  height: 700,
  bgcolor: "background.paper",
  borderRadius: "5px",
  p: 4,
};

const styleForSuperAdmin = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1050,
  height: 700,
  bgcolor: "background.paper",
  borderRadius: "5px",
  p: 4,
};

export default function CoachManagementModal(props) {
  const axios = useAxiosPrivate();
  const role = useSelector((state) => state.auth.role);
  const { setOpen, open } = props;
  const [data, setData] = useState([]);
  const [displayMessage, setDisplayMessage] = useState({
    show: false,
    message: "",
  });

  useEffect(() => {
    loadData();
    // eslint-disable-next-line
  }, [open]);

  const loadData = async (e) => {
    try {
      const { data } = await axios.get("/team/admins");
      const filterData = data?.data;

      const sortByFirstName = (a, b) => {
        const nameA = (a.first_name || "").toLowerCase();
        const nameB = (b.first_name || "").toLowerCase();

        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      };

      const filterDataBySuperAdmin = filterData
        .filter(
          (item) =>
            item?.role === "SUPER_ADMIN" && item?.user_status === "ACTIVE"
        )
        .sort(sortByFirstName);

      const filterDataByAdmin = filterData
        .filter(
          (item) => item?.role === "ADMIN" && item?.user_status === "ACTIVE"
        )
        .sort(sortByFirstName);

      const filterDataByCoach = filterData
        .filter(
          (item) =>
            ["USER", "USER_TECHNICIAN", "USER_PHYSICIAN"].includes(
              item?.role
            ) && item?.user_status === "ACTIVE"
        )
        .sort(sortByFirstName);

      setData([
        ...filterDataBySuperAdmin,
        ...filterDataByAdmin,
        ...filterDataByCoach,
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={
            role === "USER"
              ? styleForCoach
              : role === "ADMIN"
              ? styleForAdmin
              : styleForSuperAdmin
          }
        >
          <Grid container>
            <Grid
              item
              md={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <ModalCloseButton
                onClick={() => setOpen(false)}
                style={{ position: "static" }}
              />
            </Grid>
            <Grid
              item
              md={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <p className={styles.CoachManagementTopText}>Admin Management</p>
            </Grid>
            {displayMessage?.show && (
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <p className={styles.CoachManagementNotificationText}>
                  {displayMessage?.message}
                </p>
              </Grid>
            )}
          </Grid>
          {role === "USER" ? (
            <>
              <Grid
                container
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid container style={{ width: "40.5rem" }}>
                  <Grid
                    item
                    md={4}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <p className={styles.tittleText}>Name</p>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <p className={styles.tittleText}>Email</p>
                  </Grid>
                  <Grid
                    item
                    md={2}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <p className={styles.tittleText}>Level</p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box className={styles.boxCSS}>
                  {data.map((item) => (
                    <Fragment key={item.id}>
                      <Grid container style={{ marginTop: "1rem" }}>
                        <Grid
                          item
                          md={1}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Avatar
                            alt="Remy Sharp"
                            src={item.avatar_url}
                            sx={{ width: 35, height: 35 }}
                          />
                        </Grid>
                        <Grid
                          item
                          md={3}
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          <Grid container>
                            <Grid
                              item
                              md={12}
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <p className={styles.tittleTextData1}>
                                {item?.first_name ?? "-"}
                              </p>
                            </Grid>
                            <Grid
                              item
                              md={12}
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <p className={styles.tittleTextData2}>
                                {item?.last_name ?? "-"}
                              </p>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <p className={styles.tittleTextData}>{item?.email}</p>
                        </Grid>
                        <Grid
                          item
                          md={2}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Chip
                            label={
                              item?.role === "SUPER_ADMIN"
                                ? "Super Admin"
                                : item?.role === "ADMIN"
                                ? "Admin"
                                : item?.role === "USER_TECHNICIAN"
                                ? "Technician"
                                : item?.role === "USER_PHYSICIAN"
                                ? "Physician"
                                : "User"
                            }
                            size="small"
                            style={{
                              backgroundColor: "#A6DCE5",
                              padding: "0.5rem 0.5rem 0.5rem 0.5rem",
                            }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container style={{ marginTop: "1rem" }}>
                        <Grid item md={12}>
                          <hr style={{ border: "0.1px solid #A6DCE5" }} />
                        </Grid>
                      </Grid>
                    </Fragment>
                  ))}
                </Box>
              </Grid>{" "}
            </>
          ) : role === "SUPER_ADMIN" ? (
            <CoachManagementModalForSuperAdmin
              data={data}
              loadData={loadData}
              setDisplayMessage={setDisplayMessage}
            />
          ) : (
            <CoachManagementModalForAdmin
              data={data}
              loadData={loadData}
              setDisplayMessage={setDisplayMessage}
            />
          )}
        </Box>
      </Modal>
    </div>
  );
}
